<template>
  <div
    className="d-none"
    aria-hidden="true"
  >
    <svg xmlns="http://www.w3.org/2000/svg">
      <slot />
    </svg>
  </div>
</template>
